import { render, staticRenderFns } from "./details.vue?vue&type=template&id=73da63b4&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./details.vue?vue&type=style&index=1&lang=css&"
import style2 from "./details.vue?vue&type=style&index=2&id=73da63b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da63b4",
  null
  
)

export default component.exports